export enum WidgetType {
    Instant = 'instant',
    Modal = 'modal'
}